var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"tooltip-button",attrs:{"id":_vm.tooltipId},on:{"click":function($event){$event.stopPropagation();}}},[_c('fa-icon',{staticClass:"tooltip-button__icon",attrs:{"icon":"info-circle"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }